import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import React, { useEffect, RefObject } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  inputMessage: string;
  setInputMessage: (value: string) => void;
  handleSendMessage: () => void;
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  /** When false, user must be connected to LiveKit before sending (avoids server errors after room close). */
  disabled?: boolean;
}

export default function ChatInput({
  inputMessage,
  setInputMessage,
  handleSendMessage,
  textareaRef,
  disabled = false,
}: Props) {
  // const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [inputMessage, textareaRef]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (disabled) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="w-full bg-background p-1 px-1.5 flex items-center rounded-3xl border focus-within:ring-1 focus-within:ring-blue-500 transition-colors">
      <Textarea
        value={inputMessage}
        onChange={(e) => setInputMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={disabled ? t("chat_not_connected") : t("wrtie_here")}
        rows={1}
        ref={textareaRef}
        disabled={disabled}
        className="w-full resize-none overflow-hidden bg-transparent dark:bg-transparent border-0 rounded-none  px-4 py-2 text-base shadow-none placeholder:text-gray-500 focus:ring-0 focus-visible:ring-0 focus-visible:outline-none focus:outline-none min-h-[36px] max-h-40 disabled:opacity-60"
      />
      {inputMessage.trim() && !disabled && (
        <Button
          onClick={handleSendMessage}
          size="sm"
          className="rounded-full h-9 w-9 bg-blue-500 hover:bg-blue-600 transition-colors p-2.5"
        >
          <Send className="text-white" size={18} />
        </Button>
      )}
    </div>
  );
}
